module.exports = __webpack_public_path__ + "front/img/7.25d3cc02.png";